__turbopack_context__.v({
  "draw": "H8JXSa_draw",
  "drawn": "H8JXSa_drawn",
  "list": "H8JXSa_list",
  "mark": "H8JXSa_mark",
});
